import type { PropsWithChildren, FunctionComponent } from 'react'
import { Box } from '../../../../../../../../dash-blocks/box/Box'
import { type OrderType } from '../../../../../../utils/orders.types'
import {
  parseDateAndTimeFromDeliveryOption,
  parseDateAndTimeFromEta,
} from './utils/OrdersListTableEtaCell.utils'

interface Props {
  eta: string | null
  deliveryOption: string | null
  orderType: OrderType
}

export const OrdersListTableEtaCell: FunctionComponent<PropsWithChildren<Props>> = ({
  eta,
  deliveryOption,
  orderType,
}) => {
  const { dateStr, timeStr } =
    orderType === 'pickup' && deliveryOption !== 'PickupEta'
      ? parseDateAndTimeFromDeliveryOption(deliveryOption || '')
      : parseDateAndTimeFromEta(eta || '')

  return (
    <Box>
      {dateStr && (
        <Box testId="eta-cell-date" marginBottom="xxsmall">
          {dateStr}
        </Box>
      )}
      <Box testId="eta-cell-time">{timeStr}</Box>
    </Box>
  )
}
